/**
 * humanizeSendError — turn raw RPC exception strings from
 * fn_send_message / fn_send_community_message into friendly toasts.
 */
export const humanizeSendError = (raw: string | null | undefined): string => {
  if (!raw) return "Couldn't send. Try again.";
  // Postgres exception format: "cooldown:30"
  const cooldown = raw.match(/cooldown:(\d+)/);
  if (cooldown) {
    const s = Number(cooldown[1]);
    return `RAELA flagged your last message — please wait ${s}s before sending again.`;
  }
  if (raw.includes("monthly_cap_exceeded")) return "You've hit your monthly message cap.";
  if (raw.includes("muted")) return "You're temporarily muted in this room.";
  if (raw.includes("signal_tier_read_only")) return "Signal tier is read-only in community rooms.";
  if (raw.includes("not_room_member")) return "Join this room to post.";
  if (raw.includes("not_a_member")) return "You're not part of this conversation.";
  if (raw.includes("empty_body")) return "Type something to send.";
  if (raw.includes("media_required")) return "Attach a file to send.";
  return raw;
};
